import {useLayoutEffect, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import {Box} from '../../styled';
import * as Styled from './SearchResultsStyles';
import SearchStore from '../../xstores/search';
import useObservable from '../../hooks/useObservable';
import ResultItem from './ResultItem';
import {Spinner} from 'react-bootstrap';


const ResultsContainer = ({ showDetails }:any) => {
  const [oldLength, setOldLength] = useState(0);
  const hasMore = useObservable(SearchStore.hasMore$, true);
  const displayResults = useObservable(SearchStore.displayResults$, []);
  const isLoading = useObservable(SearchStore.loading$, false);
  const highlightWords = useObservable(SearchStore.highlights$, []);
  const goNextPage = async () => {
    await SearchStore.nextPage();
  }
  const showItemDetails = (item:any) => {
    showDetails(item);
  }
  useLayoutEffect(() => {
    if (!isLoading || !displayResults.length) {
      return;
    }
    if (displayResults.length > oldLength) {
      //console.log('browser done new page')
      setOldLength(displayResults.length);
    }

  }, [isLoading, displayResults, oldLength]);
  if (isLoading) {
    return null;
  }
  return (
    <Box
      margin={'86px 20px 50px'}
      display={'flex'}
      flexDirection={'column'}
    >
      <InfiniteScroll
        style={{ overflow: 'none' }}
        loadMore={goNextPage}
        hasMore={hasMore}
        initialLoad={false}
        loader={(
          <Box key={'page loader'} mt={displayResults.length ? 20 : 90} mb={20}>
            <Styled.SpinnerContainer>
              <Spinner animation="border" className="trova-color" />
            </Styled.SpinnerContainer>
          </Box>
        )}
      >
        {
          displayResults.map( (e:any) => (
            <ResultItem
              key={e.displayId}
              item={e}
              highlightWords={highlightWords}
              onClick={showItemDetails}
            />
          ))
        }
        {
          !hasMore && !!displayResults.length && (
            <Styled.SpinnerContainer>
              You have reached the end of available results
            </Styled.SpinnerContainer>
          )
        }
      </InfiniteScroll>
    </Box>
  )
}

export default ResultsContainer;